import * as React from 'react'
import { FC, useState, useEffect } from 'react'

import { cls } from '../../utils/utils'
import { ISvgIconProps } from './SvgIcon.types'
import * as styles from './SvgIcon.module.scss'

export const svgIconsCache: Record<string, string> = {}

const SvgIcon: FC<ISvgIconProps & { inline?: boolean }> = ({ className, href, inline }) =>
  inline ? (
    <SvgIconBlob href={href} className={className} />
  ) : (
    <svg className={className}>
      <use href={href} />
    </svg>
  )

const SvgIconBlob: FC<ISvgIconProps> = ({ className, href }) => {
  if (!href) return null
  const [svgRowString, setSvgRowString] = useState('')
  useEffect(() => {
    if (href in svgIconsCache) return setSvgRowString(svgIconsCache[href])
    const fetchAndReadBlob = async (src: string) => {
      try {
        const response = await fetch(src)
        if (response.status >= 400) {
          throw new Error(`Couldn't fetch src = ${src}`)
        }
        const text = await response.text()
        svgIconsCache[href] = text
        setSvgRowString(text)
      } catch (error) {
        console.error(error)
      }
    }

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    void fetchAndReadBlob(href)
  }, [href])
  return <div className={cls(styles.removePadding, className)} dangerouslySetInnerHTML={{ __html: svgRowString }} />
}

export default SvgIcon
